/**
 * Canonical types for operation progress feedback.
 *
 * {@link OperationProgress} is defined in `@audiocontrol/sampler-library`
 * (the lower-level module) and re-exported here so that editor consumers
 * can import everything progress-related from a single place.
 *
 * UI-specific types ({@link OperationState}) and utility functions
 * ({@link isOperationComplete}, {@link getOverallPercent}, {@link formatBytes})
 * live here because they depend on React/UI patterns that don't belong
 * in sampler-library.
 */
/**
 * Whether an operation has completed (all steps done).
 */
export function isOperationComplete(state) {
    if (state.isOperating || !state.progress)
        return false;
    const { currentStep, totalSteps, bytesSent, bytesTotal } = state.progress;
    return currentStep >= totalSteps && (bytesTotal === 0 || bytesSent >= bytesTotal);
}
/**
 * Compute overall percentage weighted by bytes, not step count.
 */
export function getOverallPercent(progress) {
    const { bytesSent, bytesSentAllSteps, bytesTotalAllSteps } = progress;
    if (bytesTotalAllSteps <= 0)
        return 0;
    return Math.min(100, Math.floor(((bytesSentAllSteps + bytesSent) / bytesTotalAllSteps) * 100));
}
/**
 * Format byte count for display (e.g., "42,880" or "1.2 MB").
 */
export function formatBytes(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
//# sourceMappingURL=operation-progress.js.map